import { createRootRouteWithContext, Outlet, redirect } from '@tanstack/react-router'
import { Layout } from '../components/Layout'

export interface RouterContext {
  isAuthenticated: boolean
}

export const rootRoute = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
})

function RootComponent() {
  return (
    <Layout>
      <Outlet />
    </Layout>
  )
}

/** Shared beforeLoad guard — redirects to /login if not authenticated */
export function requireAuth({ context }: { context: RouterContext }) {
  if (!context.isAuthenticated) {
    throw redirect({ to: '/login' })
  }
}
